export class FeatureMetaData {
  featureIdentifier: string;
  featureName: string;
  resourceTitle?: string;
  creationDate: string;
  revisionDate?: string;
  start: string;
  end?: string;
  interpretation: string;
  sequenceNumber: string;
  correctionNumber: string;
  originatorOrganisation: string;
  dataProviderOrganisation: string;
  dataProviderUsername?: string;
  constructor(init: FeatureMetaData) {
    Object.assign(this, init);
  }
}
